import BorderBox from 'components/shared/generic/borderBox/BorderBox';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';

const TellGatewayAccountPermissions = () => {
    const translate = useTranslate('consent');

    const sections = [
        {
            isHeader: true,
            key: 'consentDetails.permissionsRequested',
        },
        {
            isHeader: true,
            key: 'consentDetails.accountDetails',
        },
        'consentDetails.accountNameAndSortCode',
        'consentDetails.accountBalance',
        {
            isHeader: true,
            key: 'consentDetails.accountTransactions',
        },
        'consentDetails.incomingTransactions',
        'consentDetails.outgoingTransactions',
        'consentDetails.incomingTransactionDetails',
        'consentDetails.outgoingTransactionDetails',
        {
            isHeader: true,
            key: 'consentDetails.regularPayments',
        },
        'consentDetails.directDebits',
        'consentDetails.standingOrder',
        'consentDetails.scheduledPayments',
    ];

    return (
        <BorderBox className="consent-permissions">
            {sections.map((item, idx) => {
                const isHeader = typeof item === 'object' && item.isHeader;
                const key = typeof item === 'string' ? item : item.key;

                return (
                    <Typography
                        key={key}
                        tag={isHeader && idx === 0 ? 'h1' : 'p'}
                        className={
                            isHeader && idx !== 0
                                ? 'consent-permissions-header'
                                : undefined
                        }
                    >
                        {translate(key)}
                    </Typography>
                );
            })}
        </BorderBox>
    );
};

export default TellGatewayAccountPermissions;
